export default "__VITE_ASSET__431faea6__"